import {useAutoAnimate} from '@formkit/auto-animate/react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {GroupConfig} from '~/SignUpSheets/Create/routes/Customize/components/GroupConfig/GroupConfig';
import {Builder} from '~/SignUpSheets/Create/routes/Customize/components/Builder/Builder';
import {GroupTools} from './GroupTools';
import {useUpdateSheet} from '~/SignUpSheets/hooks/useUpdateSheet';
import {selectNumSignupOptionGroups} from '~/SignUpSheets/reducers/sheet/selectors';

export const GroupBuilder = ({
  groupId,
  isDesktop = false,
  open = true,
  onToggle,
  trackChangeUpstream,
}) => {
  const [groupAnimation] = useAutoAnimate({
    duration: 350,
    easing: 'ease-in-out',
  });
  const numGroups = useSelector(selectNumSignupOptionGroups);
  const {deleteGroup, duplicateGroup} = useUpdateSheet();

  const handleDuplicate = useCallback(
    (group) => {
      duplicateGroup(group, trackChangeUpstream);
    },
    [duplicateGroup, trackChangeUpstream]
  );

  const handleDelete = useCallback(
    (group) => {
      trackChangeUpstream?.([group]);
      deleteGroup(group);
    },
    [duplicateGroup, trackChangeUpstream]
  );

  const GroupToolsElement = useMemo(
    () => (
      <GroupTools
        groupId={groupId}
        numGroups={numGroups}
        isDesktop={isDesktop}
        onDuplicateGroup={handleDuplicate}
        onDeleteGroup={handleDelete}
      />
    ),
    [numGroups, groupId, isDesktop, handleDuplicate, handleDelete]
  );

  return (
    <div className={cx('signup-sheet__slot-builder-group', {open})} ref={groupAnimation}>
      <GroupConfig
        groupId={groupId}
        isDesktop={isDesktop}
        expanded={open}
        onToggle={(newStatus) => onToggle?.(groupId, newStatus)}
        toolsElement={isDesktop ? null : GroupToolsElement}
      />
      {open && <Builder groupId={groupId} trackChangeUpstream={trackChangeUpstream} />}
      {isDesktop ? GroupToolsElement : null}
    </div>
  );
};

GroupBuilder.propTypes = {
  groupId: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
};
